import React, { useState, useEffect } from 'react';
import { processPostsData } from '../../utils/postUtils.js';
import PostCardSlider from './PostCardSlider';

function HomeWidgetPopularPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const startDate = oneMonthAgo.toISOString().slice(0, 10);

    fetch(`/api/posts?sortColumn=views&sortOrder=DESC&pageSize=10&status=published&startDate=${startDate}`)
      .then(res => res.json())
      .then(data => {
        if (data.data?.posts) {
          setPosts(processPostsData(data.data.posts));
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return <PostCardSlider posts={posts} loading={loading} />;
}

export default HomeWidgetPopularPosts;
